<div class="footer" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center start"
     fxLayoutAlign.lt-md="start center" fxLayoutGap="60px">
  <div class="company">
    <img class="logo" src="../../../assets/images/footer/abc-logo-grey-blue.png"/>
    <h3>ABC Complett Ladeneinrichtungs GmbH</h3>
    <a class="map-link" [routerLink]="['/dialog/route']">
      <p>Perelsplatz 18</p>
      <p>12159 Berlin</p>
    </a>
    <a class="phone-link" [routerLink]="['/dialog/telefon']"><p>030 85 99 71 - 0</p></a>
    <a class="email-link" [routerLink]="['/dialog/kontakt']"><p>E-Mail schreiben</p></a>
    <div class="social-links" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
      <a href="https://www.facebook.com/profile.php?id=100089931952268" target="_blank"
         matTooltip="Besuche uns auf facebook">
        <mat-icon svgIcon="facebook"></mat-icon>
      </a>
      <a target="_blank" matTooltip="Besuche uns auf gelbeseiten"
         href="http://adresse.gelbeseiten.de/1056666778/abc-complett-ladeneinrichtungs-gmbh/berlin/friedenau#ladenbau-und-einrichtungen;originIndex=0;origin=/abc-complett/berlin/s1/relevanz">
        <mat-icon svgIcon="gelbe_seiten"></mat-icon>
      </a>
    </div>
  </div>
  <div class="menu" fxLayout="column" fxLayoutAlign="start center">
    <h3>Navigation</h3>
    <div fxLayout="row">
      <a [routerLink]="['/abschnitt/fertig']" matTooltip="Suchen">
        <mat-icon>search</mat-icon>
      </a>
      <a (click)="openHelpOverlay()" matTooltip="Bedienungshilfe">
        <mat-icon>help</mat-icon>
      </a>
      <a [routerLink]="['/abschnitt/top']" matTooltip="Nach oben">
        <mat-icon>arrow_upward</mat-icon>
      </a>
    </div>
    <a [routerLink]="['/abschnitt/kompetenzen']">Kompetenzen! - Mehr als Branchen</a>
    <a [routerLink]="['/abschnitt/news']">News! - Aktuelle Projekte</a>
    <a [routerLink]="['/abschnitt/fertig']">Fertig! - Unsere Referenzliste</a>
    <a [routerLink]="['/abschnitt/gemeinsam']">Gemeinsam! - Von der Idee zum Shop</a>
    <a class="margin-bottom" [routerLink]="['/abschnitt/denkdran']">Denk Dran! -
      Checklisten für deine
      Planung</a>
    <a [routerLink]="['/dialog/impressum']">Impressum</a>
    <a [routerLink]="['/dialog/datenschutz']">Datenschutzerklärung</a>
    <a [routerLink]="['/dialog/bedingungen']">Verkaufs- und Lieferbedingungen</a>
  </div>
  <div class="search-keywords" fxLayout="column">
    <h3>Suchbegriffe</h3>
    <div class="keywords">
      <perfect-scrollbar>
        <ng-container *ngIf="kompetenzen">
          <ng-container *ngFor="let kompetenz of kompetenzen">
            <b>{{kompetenz.name}}</b>
            <ng-container *ngFor="let branche of kompetenz.branchen">
              <div>
                <a [routerLink]="['/branche/' + branche.id + '/' + branche.name]"><i>{{branche.name}}</i></a>:
              </div>
              <div class="margin-bottom">
                <ng-container *ngFor="let keyword of branche.keywords">
                  <a [routerLink]="['/branche/' + branche.id + '/' + branche.name]">{{keyword}}</a>&nbsp;
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </perfect-scrollbar>
    </div>
  </div>
</div>
